import React from 'react';
import { BRAND, isStoreDownloadsLive, playStoreUrl } from '../../constants/brand';
import { useStoreNotify } from './StoreNotifyContext';

const PlayStoreLink = ({ children, className }) => {
  const { openStoreNotify } = useStoreNotify();

  if (isStoreDownloadsLive()) {
    return (
      <a
        href={playStoreUrl()}
        className={className}
        target="_blank"
        rel="noopener noreferrer"
        aria-label={`Get ${BRAND.appName} on Google Play`}
      >
        {children}
      </a>
    );
  }

  return (
    <button
      type="button"
      className={`store_badge_btn${className ? ` ${className}` : ''}`}
      onClick={openStoreNotify}
      aria-label={`Get notified when ${BRAND.appName} is on Google Play`}
    >
      {children}
    </button>
  );
};

export default PlayStoreLink;
